// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingIndicator_root__v8M1H"};